export default __webpack_public_path__ + "static/media/mp_profile_Tavola disegno 1.a06c1d20.svg";